import APP_ACTIONS from '../constants/app-actions';
import LineItemAPI from '../apis/line-item';
import localStorageAPI from '../services/local-storage-api';

const lineItem = {
    addLineItem: (lineItemParams) => (dispatch, getState) => LineItemAPI.add(lineItemParams).then((response) => {
        dispatch({ type: APP_ACTIONS.ADD_PRODUCT_TO_CART, payload: response.body });
        localStorageAPI.save(getState());
        return response;
    }),
    disablingAdd: (enabled) => (dispatch, getState) => {
        dispatch({ type: APP_ACTIONS.DISABLING_ADD, payload: enabled });
        localStorageAPI.save(getState());
    },
};

export default lineItem;



/** WEBPACK FOOTER **
 ** ./src/actions/line-item.js
 **/